/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Dropbox_IngestInputs */

const es_tools_dropbox_ingest = /** @type {(inputs: Tools_Dropbox_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingestando desde Dropbox...`)
};

const en_tools_dropbox_ingest = /** @type {(inputs: Tools_Dropbox_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingesting from Dropbox...`)
};

/**
* | output |
* | --- |
* | "Ingesting from Dropbox..." |
*
* @param {Tools_Dropbox_IngestInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_dropbox_ingest = /** @type {((inputs?: Tools_Dropbox_IngestInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Dropbox_IngestInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_dropbox_ingest(inputs)
	return en_tools_dropbox_ingest(inputs)
});
export { tools_dropbox_ingest as "tools.dropbox.ingest" }